import { ElementType, HTMLAttributes } from "react";
import { cn } from "../../../lib/utils";

const TYPOGRAPHY_VARIANTS = {
  heading4: "font-medium text-[26px] leading-[40px] tracking-[-0.01em]",
  heading5: "font-medium text-[20px] leading-[32px] tracking-[-0.01em]",
  heading6: "font-medium text-[17px] leading-[28px] tracking-[-0.01em]",

  label1: "font-medium text-[15px] leading-[15px]",
  label2: "font-medium text-[13px] leading-[13px]",
  label3: "font-medium text-[11px] leading-[11px]",
  label4: "font-medium text-[10px] leading-[10px]",

  body1: "font-normal text-[15px] leading-[26px]",
  body2: "font-normal text-[13px] leading-[22px]",
  body3: "font-normal text-[11px] leading-[18px]"
} as const;

type TTypographyVariant = keyof typeof TYPOGRAPHY_VARIANTS;

const TYPOGRAPHY_COLORS = {
  zinc100: "text-innoveraZinc-100",
  zinc200: "text-innoveraZinc-200",
  zinc300: "text-innoveraZinc-300",
  zinc400: "text-innoveraZinc-400",
  zinc500: "text-innoveraZinc-500",
  zinc600: "text-innoveraZinc-600",
  zinc700: "text-innoveraZinc-700",
  zinc800: "text-innoveraZinc-800",
  zinc900: "text-innoveraZinc-900"
} as const;

type TTypographyColor = keyof typeof TYPOGRAPHY_COLORS;

type TTypographyProps = HTMLAttributes<HTMLElement> & {
  component?: ElementType;
  variant?: TTypographyVariant;
  className?: string;
  color?: TTypographyColor;
};

export function Typography(props: TTypographyProps) {
  const { component: Component = "p", variant = "body1", className, children, color, ...rest } = props;
  const variantClass = TYPOGRAPHY_VARIANTS[variant];
  const colorClass = color ? TYPOGRAPHY_COLORS[color] : "";
  return (
    <Component className={cn(variantClass, colorClass, className)} {...rest}>
      {children}
    </Component>
  );
}
